








import { Component, Mixins, Prop } from "vue-property-decorator";
import { Point, Size } from "../../domain/drawing";
import { DragHandlesMixin } from "./mixins";
import VectorResizeDragHandle from "./VectorResizeDragHandle.vue";
import MoveDragHandle from "./MoveDragHandle.vue";
import MoveDragHandleArea from "./MoveDragHandleArea.vue";

@Component({
  components: {
    VectorResizeDragHandle,
    MoveDragHandle,
    MoveDragHandleArea,
  },
})
export default class NewPageDragHandles extends Mixins(DragHandlesMixin) {
  @Prop()
  from: Point;

  @Prop()
  to: Point;

  toCenterLocation(handleSize: Size): Point {
    const difference = this.from.subtract(this.to);
    return new Point(
      (Math.abs(difference.x) - handleSize.width) / 2,
      (Math.abs(difference.y) - handleSize.height) / 2
    );
  }

  toLeftLocation(handleSize: Size): Point {
    const difference = this.from.subtract(this.to);
    return new Point(
      0,
      (Math.abs(difference.y) - handleSize.height) / 2
    );
  }

  toRightLocation(handleSize: Size): Point {
    const difference = this.from.subtract(this.to);
    return new Point(
      Math.abs(difference.x) - handleSize.width,
      (Math.abs(difference.y) - handleSize.height) / 2
    );
  }
}
